const duration = 'vs previous {duration} days';

const translations = {
  en: {
    'coaching_notes.title': 'New 1:1',
    'coaching_notes.assignedLessons.title': 'Lessons',
    'coaching_notes.takeaways.title': 'Action items',
    'coaching_notes.takeaways.complete': 'closed',
    'coaching_notes.takeaways.open': 'open',
    'coaching_notes.participant.coach': 'Coach',
    'coaching_notes.participant.employee': 'Coachee',
    'coaching_notes.cancel': 'Cancel',
    'coaching_notes.save': 'Save & Exit',
    'coaching_notes.share': 'Share',
    'coaching_notes.edit': 'Edit',
    'coaching_notes.error': 'Something went wrong',
    'coaching_notes.lastUpdated': 'Last saved on {date}',
    'coaching_notes.sharedOn': 'Shared on {date}',
    'coaching_notes.unsavedChanges': 'Unsaved changes',
    'coaching_notes.no_notes': 'No notes entered',
    'coaching_notes.remove_lesson': 'Remove Lesson',
    'coaching_notes.assign_lesson': 'Assign Lesson',
    'coaching_notes.assigned_lesson': 'Assigned Lesson',
    'coaching_notes.no_lessons': 'No lessons assigned',

    'coaching_notes.session.title': 'Title',
    'coaching_notes.session.title_placeholder': 'Title',

    'coaching_notes.saved.title': '1:1',
    'coaching_notes.saved.cancel': 'Close',
    'coaching_notes.saved.share': 'Shared',
    'coaching_notes.saved.reshare': 'Resend email recap',

    'coaching_notes.takeaway.placeholder': 'Action',
    'coaching_notes.takeaway.open': 'Open',
    'coaching_notes.takeaway.cancel': 'Cancel',
    'coaching_notes.takeaway.save': 'Save',
    'coaching_notes.takeaway.negative': 'Needs Work',
    'coaching_notes.takeaway.positive': 'Keep It Up',
    'coaching_notes.takeaway.edit': 'Edit',

    'coaching_notes.kudos.title': 'Give kudos',

    'coaching_notes.sharedModal.success': 'Success!',
    'coaching_notes.sharedModal.message':
      'Way to go! Your notes are now on the way to ',
    'coaching_notes.sharedModal.viewSession': 'Back to session',
    'coaching_notes.sharedModal.newSession': 'Start new 1:1',

    'coaching_notes.privateNote.title': 'Personal notes',
    'coaching_notes.privateNote.placeholder': 'Enter personal notes',

    'coaching_notes.publicNote.title': '{whose} notes',
    'coaching_notes.publicNote.placeholder': 'Enter notes',
    'coaching_notes.publicNote.empty': 'No notes',

    'coaching_notes.topicReferenceType.qa': 'QA Review',
    'coaching_notes.topicReferenceType.feedback': 'Feedback',
    'coaching_notes.topicReferenceType.metric': 'Performance Metric',

    'company.noData': 'No data found',
    'company.error': 'Something went wrong. Please try refreshing the page.',
    'company.authError':
      'Authorization session expired. Please try refreshing the page.',
    'company.datePicker': 'DATE RANGE',
    'company.export.generate': 'Generate CSV',
    'company.export.generating': 'Generating...',
    'company.export.download': 'Download CSV',
    'company.channels': 'CHANNEL',
    'company.channels.placeholder': 'Select channels',
    'company.languages': 'LANGUAGE',
    'company.languages.placeholder': 'Select languages',
    'company.answers.placeholder': 'Select an answer',
    'company.answers': 'ANSWER',
    'company.brands': 'BRANDS',
    'company.brands.placeholder': 'Select brands',
    'company.surveys': 'SURVEY',
    'company.surveys.placeholder': 'Select a survey',
    'company.tags': 'TAGS',
    'company.tags.placeholder': 'Select tags',
    'company.teams': 'TEAMS',
    'company.groups': 'GROUPS',
    'company.team_ids': 'TEAMS',
    'company.teams.placeholder': 'Search by name',
    'company.team_ids.placeholder': 'Search by name',
    'company.teams_groups': 'TEAMS or GROUPS',
    'company.teams_groups.placeholder': 'Select Team or Group',
    'company.teams_groups.tooltip':
      'This filter allows selection of Teams OR Groups. Switching between Team and Group filtering will clear currently selected filters.',
    'company.filters.selectAll': 'Select All',
    'company.filters.clearAll': 'Clear Filters',
    'company.filters.clear': 'Clear',
    'company.charts.overTimeHeader': 'Over time',
    'company.charts.channelHeader': 'By channel',
    'company.charts.brandHeader': 'By brand',
    'company.charts.languageHeader': 'By language',
    'company.starRating': 'Star rating',
    'company.percentNegative': '% Negative',
    'company.percentPositive': '% Positive',
    'company.percentFiveStar': '% Five Star',

    'company.NpsQuestion': 'NPS',
    'company.NPSQuestion': 'NPS',
    'company.FcrQuestion': '% Resolved',
    'company.FCRQuestion': '% Resolved',
    'company.ScalarQuestion': 'Scale',
    'company.MultipleChoiceQuestion': 'Multiple choice',
    'company.questionSelect': 'Select a question',
    'company.basedOn': 'Based on {count} responses',

    'company.team.name': 'Name',
    'company.team.starRating': 'Star rating',
    'company.team.starRatingChange': duration,
    'company.team.responses': 'Responses',
    'company.team.title': 'Teams',
    'company.team.percentNegative': '% Negative',
    'company.team.percentNegativeChange': duration,
    'company.team.percentPositive': '% Positive',
    'company.team.percentPositiveChange': duration,
    'company.team.percentFiveStar': '% Five Star',
    'company.team.percentFiveStarChange': duration,
    'company.team.loading': 'Value',

    'company.team.NpsQuestion': 'NPS',
    'company.team.NPSQuestion': 'NPS',
    'company.team.FcrQuestion': '% Resolved',
    'company.team.FCRQuestion': '% Resolved',

    'company.team.ScalarQuestion': 'Scale average',
    'company.team.MultipleChoiceQuestion': '% Selected answer',
    'company.team.questionChange': duration,

    'company.team.export.email': 'Email',
    'company.team.export.customEmployeeId': 'Custom Employee Id',
    'company.team.export.name': 'Name',
    'company.team.export.responses': 'Responses',
    'company.team.export.starRating': 'Star Rating',
    'company.team.export.starRatingChange': 'Star Rating Change',
    'company.team.export.percentNegative': 'Percent Negative',
    'company.team.export.percentNegativeChange': 'Percent Negative Change',
    'company.team.export.percentPositive': 'Percent Positive',
    'company.team.export.percentPositiveChange': 'Percent Positive Change',
    'company.team.export.questionChange': 'Question Change',
    'company.team.export.MultipleChoiceQuestion': 'Multiple Choice Question',
    'company.team.export.FcrQuestion': 'Fcr Question',
    'company.team.export.FCRQuestion': 'Fcr Question',
    'company.team.export.NpsQuestion': 'Nps Question',
    'company.team.export.NPSQuestion': 'Nps Question',
    'company.team.export.ScalarQuestion': 'Scalar Question',

    'company.teams.title': 'Teams',
    'company.teamMembers.title': 'Team members',
    'company.teams.link': 'See all teams',
    'company.teams.topTitle': 'Teams: most improved',
    'company.teams.bottomTitle': 'Teams: most declined',
    'company.areaOfExcellence.topTitle': 'Areas of Excellence',
    'company.areaOfImprovement.topTitle': 'Areas of Improvement',
    'company.teamMembers.link': 'See all team members',
    'company.teamMembers.topTitle': 'Team members: most improved',
    'company.teamMembers.bottomTitle': 'Team members: most declined',
    'company.tags.topAndBottom': 'Tags: top and bottom',
    'company.tags.biggestMoves': 'Tags: biggest moves',
    'company.tags.title': 'Tags',
    'company.tags.link': 'See all tags',
    'company.charts.distributionHeader': 'Distribution',
    'company.programs.totalCount': 'Total',
    'company.programs.doNotSend': 'Do Not Send',
    'company.programs.unsubscribed': 'Customer Unsubscribed',
    'company.programs.emailSuppressed': 'Email Suppressed',
    'company.programs.rejected': 'Rejected',
    'company.programs.bounced': 'Bounced',
    'company.programs.sent': 'Sent',
    'company.charts.multipleChoiceDistributionHeader':
      'Select an answer for details',
    'company.programs.response.funnel.title': 'Response funnel',
    'company.programs.response.funnel.overall': 'All surveys',
    'company.programs.deliverability.title': 'Deliverability',
    'company.programs.marketing.title': 'Marketing actions',
    'company.programs.deliverability_over_time.title':
      'Deliverability over time',
    'company.programs.marketing_actions.title': 'Marketing actions',

    'company.programs.question.StarRating': 'Star Rating',
    'company.programs.question.AreasOfImprovement': 'Areas of Improvement',
    'company.programs.question.AreasOfExcellence': 'Areas of Excellence',
    'company.programs.question.Rewards': 'Rewards',
    'company.programs.question.MultipleChoice': 'Multiple Choice',
    'company.programs.question.FCR': 'FCR',
    'company.programs.question.NPS': 'NPS',
    'company.programs.question.Scalar': 'Scale',
    'company.programs.question.Recovery': 'Recovery',

    'company.programs.team.employeeName': 'Name',
    'company.programs.team.total': 'Total',
    'company.programs.team.doNotSendPercent': 'Do Not Send',
    'company.programs.team.unsubscribedPercent': 'Unsubscribed',
    'company.programs.team.emailSuppressedPercent': 'Suppressed',
    'company.programs.team.rejectedPercent': 'Rejected',
    'company.programs.team.bouncedPercent': 'Bounced',
    'company.programs.team.deliveredPercent': 'Delivered',

    'company.subscribe': 'Subscribe',
    'company.subscriptionSettingsTitle': 'Subscription settings',
    'company.subscriptionSettings':
      'Email digests let you stay on top of changes week over week. They provide a snapshot of the data you see here and are always for the last 7 days compared to the 7 days before that. You can schedule these to be delivered to your inbox daily or weekly at the time of your choosing. Times are shown in your current timezone.',
    'company.organizations': 'ORGANIZATION',
    'company.companies.title': 'Linked accounts',
    'company.companies.placeholder': 'All organizations',

    'company.reportingGroups.title': 'Groups',

    'company.metricConfiguration.main': 'Main Metric',
    'company.metricConfiguration.first': 'First Metric',
    'company.metricConfiguration.second': 'Second Metric',
    'company.metricConfiguration.third': 'Third Metric',
    'company.metricConfiguration.title': 'Metric Configuration',
    'company.metricConfiguration.description':
      'Here you can select the specific metrics that will be visible for all users of Agent Connect for each specific feature or product. You can choose from our default metrics or any custom question metrics if you have them.',
    'company.metricConfiguration.dashboardTitle': 'Dashboard Metrics',
    'company.metricConfiguration.keyMetricTitle': 'Key Metric Set',
    'company.metricConfiguration.MetricSetsTitle': 'Metric Sets',
    'company.metricConfiguration.keyMetricDescription':
      'A great way to keep team members on top of their performance is to track the same key metrics on both the Performance report and the 1:1s context sidebar. Select a total of up to 10 metrics in the order that they’ll appear on the Performance report. Pro Tip: Metrics found on the Performance report will be available to quick-add to any team member’s upcoming 1:1 in just a couple of clicks!',
    'company.metricConfiguration.stream': 'Stream',
    'company.metricConfiguration.streamDescription':
      "The Stream is your real-time feed of customer feedback -- survey responses flow into the Stream as they're received, and reviewing the Stream is one of the best ways to encourage real-time coaching.",
    'company.metricConfiguration.trend': 'Trend',
    'company.metricConfiguration.trendDescription':
      'The Company Trends dashboard provides a top-down view of your company’s customer feedback performance & at-a-glance visibility into three key metrics of your choice.',
    'company.metricConfiguration.leaderboards': 'Leaderboards',
    'company.metricConfiguration.leaderboardsDescription':
      'Agent Connect Leaderboards help foster friendly competition and highlight high-performers on your front-line teams. Choose the metric you’d like to base your Leaderboard on and watch it update in real-time. Pro Tip: Display Agent Connect Leaderboards on wallboards in the office or leave it open on a 2nd monitor for a burst of positivity every day!',
    'company.metricConfiguration.leaderboards.advancedSettings':
      'Advanced Settings',
    'company.metricConfiguration.1on1': '1:1s Dashboard',
    'company.metricConfiguration.performanceMgmtReport':
      'Performance Management',

    'company.metricOptions.calculationOptions': 'Calculation Options',
    'company.metricOptions.thumbnailDescription':
      'These settings apply to metrics on the Stream, Trends, 1:1s, and Performance pages.',
    'company.metricOptions.reportingTimestampSelect':
      'Report feedback metrics by',
    'company.metricOptions.reportingTimestampDescription':
      'Note: Response rates as a metric will always display as 100%. This is because all requests within a selected time frame have been responded to.',
    'company.metricOptions.createdAt': 'Feedback request creation (created-at)',
    'company.metricOptions.respondedAt': 'Feedback response (responded-at)',

    'test.id': 'Test',
    'admin.company.api.fields.title': 'Interaction Fields',
    'admin.company.api.fields.description':
      "These are the interaction fields we've pulled in from your source system. Learn more about ",
    'admin.company.api.fields.descriptionLink':
      'configuring interaction fields here.',
    'admin.company.api.source.title': 'Source System',
    'admin.company.api.source.description':
      'Where should we pull your interactions from? You can add more sources later.',
    'admin.company.api.source.addSource': '+ Add source system',
    'admin.company.api.source.form.addSourceTitle': 'Add source system',
    'admin.company.api.source.form.configureSourceTitle':
      'Configure Source System',
    'admin.company.api.source.form.editSourceTitle': 'Edit source system',
    'admin.company.api.source.form.save': 'Save',
    'admin.company.api.source.form.continue': 'Continue',
    'admin.company.api.source.form.cancel': 'Cancel',
    'admin.company.api.source.form.selectSource': 'Select source system',
    'admin.company.api.source.form.subdomain': 'Zendesk subdomain',
    'admin.company.api.source.form.authorizatonType':
      'How do you want to connect?',
    'admin.company.api.source.form.authorizatonTypeLogin':
      'Use my Zendesk login',
    'admin.company.api.source.form.authorizatonTypeApiKey': 'I have an API key',
    'admin.company.api.source.form.emailPlaceholder': 'Enter email',
    'admin.company.api.source.form.apiKeyPlaceholder': 'Enter API key',
    'admin.company.api.source.form.zendeskLogin': 'Login in Zendesk',
    'admin.company.api.source.form.channels': 'Channels',
    'admin.company.api.source.form.channelsDesc':
      'Helper text about default triggers and link to help desk.',
    'admin.company.api.source.form.excludeTicketsWithTags':
      'Skip tickets with these tags',
    'admin.company.api.source.form.excludeTicketsWithTagsDesc':
      'Interactions with these tags will not trigger surveys or be available to review.',
    'admin.company.api.source.form.excludeFields':
      'Exclude these ticket fields',
    'admin.company.api.source.form.backfillDays':
      'Backfill interactions to review from the last',
    'admin.company.api.source.form.backfillMaxDays': 'Maximun is 7 days',
    'admin.company.api.source.form.doNotSend':
      'Create “Do Not Send Checkbox” ticket field?',
    'admin.company.api.source.form.doNotSendDesc':
      'When field is checked, no survey will be sent for that interaction. Learn more.',
    'admin.company.api.source.table.noData':
      'No source systems have been added.',
    'admin.company.api.source.table.col1': 'Source system',
    'admin.company.api.source.table.col2': 'Subdomain',
    'admin.company.api.source.table.col3': 'Last synced',

    'calibrations.tab.name.overview': 'Overview',
    'calibrations.tab.name.all': 'All calibrations',
    'calibrations.tab.name.allSessions': 'All Sessions',
    'calibrations.reports.filters.dateRange': 'Date range',
    'calibrations.reports.scorecard': 'Scorecard',
    'calibrations.reports.totalCalibrations': 'Total calibrations',
    'calibrations.reports.alignmentScore': 'Alignment score',
    'calibrations.reports.alignmentScoreInfo':
      '({alignedAnswersCount}) aligned answers / ({answersCount}) total answers = ({alignmentScore}%) alignment score.',
    'calibrations.reports.overview': 'Overview',
    'calibrations.reports.trendsOverTime': 'Trends over time',
    'calibrations.reports.scorecard.sectionDetails':
      'Scorecard section breakdown',
    'calibrations.reports.scorecard.questionBreakdown':
      'Scorecard question breakdown',
    'calibrations.reports.scorecard.trendsOverTime':
      'Scorecard trends over time',
    'calibrations.reports.link.seeDetails': 'See details',
    'calibrations.reports.link.seeResults': 'See results',
    'calibrations.button.newCalibration': 'New Calibration',
    'calibrations.button.totalAnswers': 'total',
    'calibrations.review.calibrationCompleted':
      'The calibration has already been completed',
    'calibrations.scorecard.backToOverview': 'Back to Overview',
    'calibrations.reports.question': 'Question',
    'calibrations.reports.section': 'Section',
    'calibrations.new.calibration.recommendations':
      'We have done some of the work for you, by detecting the alignment score your team has. Pro tip: choose the questions with the lowest alignment score',
    'calibrations.new.calibration.alignmentScoreTooltip':
      'Based on the last 7 days of calibrations',
    'calibrations.new.calibration.selectQuestions':
      'Select questions to calibrate',
    'calibrations.new.calibration.fromQuestion': 'Calibrate 1 question',
    'calibrations.new.calibration.fromQuestions':
      'Calibrate {questionNumber} questions',
    'calibrations.all.section.myCalibrations': 'My Calibrations',
    'calibrations.all.section.calibrationSessions': 'Calibration Sessions',
    'calibrations.all.section.calibrationSessionsTooltip':
      'These are sessions that you have been assigned as a participant',
    'calibrations.all.section.completed': 'Completed',
    'calibrations.all.status.inProgress': 'In progress',
    'calibrations.all.status.awaitingConsensus': 'Awaiting consensus',
    'calibrations.all.status.viewResults': 'View results',
    'calibrations.all.noActiveCalibrations':
      'You have no calibrations to complete or in progress.',
    'calibrations.all.noCompletedCalibrations':
      'You have no completed calibrations.',
    'calibrations.sessions.title': 'All Sessions',
    'calibrations.sessions.section.incomplete':
      'In progress \\ Awaiting consensus',
    'calibrations.sessions.section.completed': 'Completed',

    'scorecards.seeDetails': 'Click to see scorecard details',
    'scorecards.details': 'Scorecard details',

    'qa.reviews.acknowledge.error':
      'Sorry, there was an error while acknowledging your review',
    'qa.review.header.button.acknowledge.tooltipText': 'Looks good!',
    'qa.review.header.button.appeal.tooltipText': 'Appeal review',
    'qa.review.header.button.appeal.numberOfQuestionSelected':
      '{number} questions selected for appeal',
    'qa.review.header.button.resolveAppeal.resolveText': 'Resolve Appeal',
    'qa.review.header.button.resolveAppeal.resolvedText': 'Appeal Closed',
    'qa.review.header.button.submit': 'Submit appeal',
    'qa.review.header.menu.editScore': 'Edit score',
    'qa.review.header.menu.deleteReview': 'Delete review',
    'qa.review.answer.button.appealAnswer': 'Appeal this answer',
    'qa.review.answer.appealReasonLabel': 'Add reason for appeal*',
    'qa.review.answer.appealedReasonLabel': 'Reason for appeal*',
    'qa.review.answer.appealResolutionLabel': 'Resolution to appeal*',
    'qa.review.answer.appealedDetails': 'Appeal submitted by {name} on {date}',
    'qa.review.answer.resolutionDetails': 'Resolved by {name} on {date}',
    'qa.review.annotations.addAnnotation': 'Add Annotation',
    'qa.review.annotations.add': 'Add',
    'qa.review.annotations.save': 'Save',
    'qa.review.annotations.cancel': 'Cancel',
    'qa.review.sentiment.callTimeline': 'Call Timeline',
    'qa.review.sentiment.noAudio': 'Cannot retrieve audio',
    'qa.review.sentiment.noAudioDescription':
      'Please try again. If the problem persist, contact your local administrator.',
    'qa.review.chat.noMessages': 'Start a Conversation',

    'qa.header.filters.events.label': 'Events',
    'qa.header.filters.events.placeholder': 'Search by events',
    'qa.header.filters.events.unacknowledged': 'Unacknowledged',
    'qa.header.filters.events.appealed': 'Open Appeals',
    'qa.header.filters.events.resolved': 'Closed Appeals',

    'qa.reports.appealedReviews': 'Appealed',

    'qa.transcript.fetchError':
      "There was an error fetching this interaction's transcript. Please try again later.",

    'global.learnMore': 'Learn more.',
    'global.days': 'days',
    'global.yes': 'yes',
    'global.no': 'no',
    'global.dayOf': 'Day of ',
    'global.weekOf': 'Week of ',
    'global.cancel': 'Cancel',
    'global.open': 'Open',
    'global.closed': 'Closed',
    'global.sortBy': 'Sort by',
    'global.sentiment.positive': 'Positive',
    'global.sentiment.negative': 'Negative',
    'global.sentiment.stronglyPositive': 'Strongly Positive',
    'global.sentiment.stronglyNegative': 'Strongly Negative',
    'global.sentiment.mixedOpinion': 'Mixed Opinion',
    'global.sentiment.neutral': 'Neutral',

    'solicitation.show.isArchived': 'This feedback has been removed',

    'leaderboard.error':
      'Something went wrong. Please try refreshing the page.',
    'leaderboard.filters.timeframe': 'Timeframe',
    'leaderboard.filters.groups': 'Teams or Groups',
    'leaderboard.filters.channels': 'Channels',
    'leaderboard.filters.interval': 'Interval Type',
    'leaderboard.filters.info':
      'This leaderboard shows team members ranked by {metric_title} (ties are broken by {source_type} count). The leaderboard resets each Sunday at midnight and data is shown in real-time. This page will automatically refresh every 15 minutes. Arrows display change in rank from the previous {interval_type} to today.{br}{br}Note:{br}Team members must have at least {threshold} in the selected {interval_type} in order to be eligible for the leaderboard.',
    'leaderboard.filters.header': 'Settings',
    'leaderboard.filters.cancel': 'Cancel',
    'leaderboard.filters.update': 'Update',
    'leaderboard.notfound':
      'There are no team members eligible for the leaderboard with the selected filters.',
    'leaderboard.ticker.justgot': 'just got a',
    'leaderboard.ticker.review': 'Review',
  },
};

const translate = (translationKey, locale = 'en') =>
  translations[locale][translationKey];

export { translations, translate };
